module.exports = __webpack_public_path__ + "images/alphabet34c668a178c398f9dc9be4902ee33b65.png";